module.exports = __webpack_public_path__ + "images/img-2GuTk8G.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/postback-info/ru/5.png
// module id = 2330
// module chunks = 0